import styled from "styled-components";

export const SectionTitleLeft = styled.h3`
text-transform: uppercase;
letter-spacing: 0.05em;
`

export const SectionTitle = styled(SectionTitleLeft)`
text-align: center;
`